
jQuery('.sort-by')
    .val('{{ collection.sort_by | default: collection.default_sort_by }}')
    .on('change', function () {
    Shopify.queryParams.sort_by = jQuery(this).val();
    location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
    });
    
/* Product Tag Filters - Good for any number of filters on any type of collection page. */
Shopify.queryParams = {};
if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
    }
}

var collFilters = jQuery('.coll-filter');
collFilters.change(function () {
    var newTags = [];
    var newURL = '';
    collFilters.each(function () {
    if (jQuery(this).val()) {
        newTags.push(jQuery(this).val());
    }
    });

    if (newTags.length) {
    Shopify.queryParams.constraint = newTags.join('+');
    } else {
    delete Shopify.queryParams.constraint;
    }
    location.search = jQuery.param(Shopify.queryParams);
});




const CollectionPageFunctions = () => {
const collDesp = document.querySelector('.collection-top-banner .collection-description');
const moreBtn = document.querySelector('.collection-top-banner  span.more-btn');
const lessBtn = document.querySelector('.collection-top-banner  span.less-btn');
const closeBtn = document.querySelector('.collection-top-banner  .readmore-close');
const modalX = document.querySelector('.collection-top-banner  .collection-info-modal-close');
const collModal = document.querySelector('.collection-top-banner .collection-info-modal');
const collOverlay = document.querySelector('.collection-top-banner .collection-overlay');

if (collDesp.textContent.trim().length < 400) {
    collDesp.style.maxHeight = 'unset';
    moreBtn.style.display = 'none';
}

moreBtn &&
    moreBtn.addEventListener('click', function () {
    collModal.classList.remove('modal-hide');
    collModal.classList.add('modal-transition');
    collOverlay.classList.remove('modal-hide');
    collOverlay.classList.add('modal-transition');
    });
lessBtn &&
    lessBtn.addEventListener('click', function () {
    collModal.classList.add('modal-hide');
    collModal.classList.remove('modal-transition');
    collOverlay.classList.add('modal-hide');
    collOverlay.classList.remove('modal-transition');
    });

modalX &&
    modalX.addEventListener('click', function () {
    lessBtn.click();
    });
collOverlay &&
    collOverlay.addEventListener('click', function () {
    lessBtn.click();
    });

let gridItem = document.querySelectorAll('.product-grid .item');
gridItem.forEach((item) => {
    let swatchItem = item.querySelectorAll('#colourSwatches li');
    if (swatchItem.length > 11) {
    item.querySelector('#colourSwatches .more-colour').classList.add('more-colur-block');
    }
    if (swatchItem.length == 3) {
    item.querySelector('#colourSwatches .more-colour').classList.add('two-colur-block-mobile');
    }

    if (window.innerWidth <= 768) {
    if (swatchItem.length > 3) {
        item.querySelector('#colourSwatches .more-colour').classList.add('more-colur-block');
    }
    }
    swatchItem.forEach((item) => {
    let bg = item.querySelector('.swatchBlock') && item.querySelector('.swatchBlock').style.backgroundColor;
    if (item.querySelector('.tooltip')) {
        item.querySelector('.tooltip').style.backgroundColor = bg;
        let tempBg = bg.replace('(', ' ');
        tempBg = tempBg.replace(')', ' ');
        tempBg = tempBg.replace('rgb', ' ');
        tempBg = tempBg.split(',');
        if (tempBg[0] > 200 && tempBg[1] > 200 && tempBg[2] > 200) {
        item.querySelector('.tooltip').style.color = '#000';
        }
    }
    });
});
document.querySelectorAll('.swatchOptionBlocks .quickBuy').forEach((buy) => {
    buy.addEventListener('click', () => {
    const timeCount = new Date(new Date().getTime() + 30 * 60 * 1000);
    localStorage.setItem('cartTimer', JSON.stringify(timeCount));
    });
});

const preloaded = new Set();

function preloadImage(img) {
    if (!preloaded.has(img)) {
    const image = new Image();
    image.src = img.dataset.src;
    preloaded.add(img);
    }
}
};

CollectionPageFunctions();